/** Exact predicate for JavaScript's string runtime type. */
export const isStringValue = (value: unknown): value is string =>
  typeof value === "string";

/** Exact predicate for JavaScript's number runtime type, including NaN and infinities. */
export const isNumberValue = (value: unknown): value is number =>
  typeof value === "number";

/** Exact predicate for JavaScript's boolean runtime type. */
export const isBooleanValue = (value: unknown): value is boolean =>
  typeof value === "boolean";

/** Exact predicate for callable JavaScript values. */
export const isFunctionValue = (
  value: unknown,
): value is (...args: never[]) => void => typeof value === "function";

/** Exact predicate for JavaScript's object runtime type, which includes null. */
export const hasObjectType = <Value>(
  value: Value,
): value is Value & (object | null) => typeof value === "object";

/** Exact predicate for JavaScript's symbol runtime type. */
export const isSymbolValue = (value: unknown): value is symbol =>
  typeof value === "symbol";

/** Exact predicate for JavaScript's bigint runtime type. */
export const isBigIntValue = (value: unknown): value is bigint =>
  typeof value === "bigint";
